import * as React from 'react';
import { SVGProps } from 'react';

const IconNodeStartSizeS = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M1 4a1 1 0 0 1 1-1h11a1 1 0 0 1 1 1v1a3 3 0 1 0 0 6v1a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V4z" />
    <path d="M14 10a2 2 0 1 0 0-4 2 2 0 0 0 0 4z" />
  </svg>
);
export default IconNodeStartSizeS;
